import {
  DegreeDetailRedesignData,
  DegreeDetailRedesignVariant,
  DegreeDetailRedesignTestResult,
  UseDegreeDetailRedesignTraffic,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "degreeDetailPageRedesignTestV52";

/**
 * Hook for the degree detail redesign experiment.
 * This experiment can return one of two variants:
 * - control: Original design
 * - redesign: New design
 */
const useDegreeDetailRedesignTrafficV5_2: UseDegreeDetailRedesignTraffic =
  () => {
    // Call the Monarch API to get the experiment result
    const { isLoading, value } = useMonarchRule<{
      data: DegreeDetailRedesignData;
    }>(CUSTOM_RULE_ID, {});

    // If still loading or no value returned, return loading state
    if (isLoading || !value) {
      return {
        isLoading,
      } as DegreeDetailRedesignTestResult;
    }

    // Determine the variant based on the returned data
    const variant: DegreeDetailRedesignVariant = value.data.showRedesign
      ? "redesign"
      : "control";

    // Extract data for the experiment
    const { data } = value;

    // Return the experiment result with proper typing
    return {
      isLoading: false,
      variant,
      data,
    };
  };

export default useDegreeDetailRedesignTrafficV5_2;
